const viewState = {
  notifications: [],
  version: {
    current: "",
    old: "",
  },
  isLoading: false,
  isLoadingMain: false,
};

const view = {
  namespaced: true,
  state: viewState,
  getters: {
    isMaintenance(state) {
      return state.notifications.some((item) => item.maintenance === true);
    },
  },
  mutations: {
    setNotifications(state, payload) {
      if (payload && Array.isArray(payload)) {
        state.notifications = payload;
      }
    },
    reset(state) {
      Object.assign(state.version, viewState.version);
      state.isLoading = false;
      state.isLoadingMain = false;
    },
  },
  actions: {
    setNotifications({ commit }, response) {
      commit("setNotifications", response);
    },
    reset({ commit }) {
      commit("reset");
    },
  },
};

export default view;
